module.exports = __webpack_public_path__ + "4ea8b46a9375bf92c085deb7aa77eecc.pdf";